import type { SvgIconComponent } from '@mui/icons-material';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import QuizOutlinedIcon from '@mui/icons-material/QuizOutlined';

import { PERMISSIONS, type Permission } from '@/constants/permissions';

export interface NavItem {
  label: string;
  path: string;
  icon: SvgIconComponent;
  permission: Permission;
}

/**
 * Single source of truth for the sidebar. Each entry's `permission` is
 * checked against the current user before rendering, so the menu and the
 * route guards never drift out of sync - both read from this file (via
 * `ROLE_PERMISSIONS`) rather than duplicating role logic.
 */
export const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: '/dashboard', icon: DashboardOutlinedIcon, permission: PERMISSIONS.DASHBOARD_VIEW },
  { label: 'Users', path: '/users', icon: PeopleOutlinedIcon, permission: PERMISSIONS.USERS_VIEW },
  { label: 'Categories', path: '/categories', icon: FolderOutlinedIcon, permission: PERMISSIONS.CATEGORIES_VIEW },
  { label: 'Quizzes', path: '/quizzes', icon: QuizOutlinedIcon, permission: PERMISSIONS.QUIZZES_VIEW },
  {
    label: 'Notifications',
    path: '/notifications',
    icon: NotificationsOutlinedIcon,
    permission: PERMISSIONS.NOTIFICATIONS_VIEW,
  },
];
